import { useStructuredContext } from "@/components/common/StructuredText"
import GridContainer from "@/components/common/GridContainer"
import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import { insetGapLeftCss } from "@/styles/globalStyles"
import SingleBulletPoint from "@/components/common/StructuredText/components/Blocks/BulletPointsWithActions/SingleBulletPoint"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled.div`
	background: ${({ theme }) => theme.colors.platinum};
	position: relative;
	padding: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} ${getCssSizeValue(48, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(32, BREAKPOINTS.MOBILE)} ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};
	display: flex;
	flex-direction: column;
	gap: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(24, BREAKPOINTS.TABLET)} ${getCssSizeValue(32, BREAKPOINTS.TABLET)}
			${getCssSizeValue(24, BREAKPOINTS.TABLET)} ${getCssSizeValue(54, BREAKPOINTS.TABLET)};
		gap: ${getCssSizeValue(16, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		${insetGapLeftCss};
		gap: ${getCssSizeValue(32)};
		padding: ${getCssSizeValue(32)} ${getCssSizeValue(32)} ${getCssSizeValue(32)} ${getCssSizeValue(40)};
	}
`

export default function BulletPointsWithActions({ data }) {
	const indent = useStructuredContext("indent")
	const width = useStructuredContext("width")
	const items = data?.items || []

	return (
		<GridContainer className={`indent-desktop-${indent} indent-tablet-1`}>
			<Wrapper className={`col-mobile-8 col-tablet-5 col-desktop-${width}`}>
				{items.map((item, index) => {
					const key = item?.id || index
					return <SingleBulletPoint key={key} data={item} />
				})}
			</Wrapper>
		</GridContainer>
	)
}
